/**
 * 上下文类型
 */
export enum ModelContextType {
    /** 文本 */
    Text = 'text',
    /** 选中的文本 */
    SelectionText = 'selectionText',
    /**
     * 专利 pn 号
     *
     * @deprecated 仅用于 @ 添加专利时使用
     *
     * TODO: 需要重构，后端支持 PN 号获取专利数据即 value 为 PN 号，现在后端接口期望 value 为 patent_id, 所以 label 是 PN 号。
     */
    PN = 'PN',
    /** 专利 id */
    PatentID = 'PatentID',
    /** 专利列表 */
    PatentList = 'PatentIdList',
    /** 占位符 */
    Placeholder = 'placeholder',

    /** 图片 */
    Image = 'image',

    /** dashboard bi chart */
    Chart = 'biChart',
}

/**
 * extra page中支持的component
 */
export enum ExtraPageName {
    AiPatentResult = 'ai-patent-result',
    PatentList = 'patent-list',
}
